import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["textContent"]

import { TaskModel } from '@/components/tasks-kanban/models';
import { ListItemModel } from '../../../models';
import { computed, PropType } from 'vue';
import { TaskCardItemWrapper } from './';
import { UserCircleIcon } from 'tir-style-system/icons/outline';
import { TirPmIconView } from 'tir-components';

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-card-observers',
  props: {
  /**Задача */
  task: { type: Object as PropType<TaskModel> },
  /**Данные об элемнте */
  element: { type: Object as PropType<ListItemModel> },
},
  setup(__props) {

const props = __props;



/**Показанные наблюдатели */
const shownPersons = computed(() => {
  const persons = props.task.Observers.slice(0, 2);
  const uniqueIds = Array.from(new Set(persons.map((p) => p.Id)));
  const personsToShow = [];
  uniqueIds.forEach((id) => {
    personsToShow.push(persons.find((p) => p.Id == id));
  });
  return personsToShow;
});
/**Скрытые наблюдатели */
const hiddenPersons = computed(() =>
  Math.max(props.task.Observers.length - shownPersons.value.length, 0),
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TaskCardItemWrapper), { element: __props.element }, {
    default: _withCtx(() => [
      (shownPersons.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shownPersons.value, (person) => {
              return (_openBlock(), _createBlock(_unref(TirPmIconView), {
                "is-rounded": "",
                size: 24,
                imageLoadUrl: person.ImageUrl,
                colorCode: person.NoPhotoColor,
                "is-bordered": false
              }, {
                mainSlot: _withCtx(() => [
                  _createTextVNode(_toDisplayString(person.FirstName[0] + person.LastName[0]), 1)
                ]),
                _: 2
              }, 1032, ["imageLoadUrl", "colorCode"]))
            }), 256)),
            (hiddenPersons.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  textContent: _toDisplayString(`+${hiddenPersons.value}`)
                }, null, 8, _hoisted_1))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["element"]))
}
}

})